// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useEffect } from "react";
import { useStableEventHandler } from "../use-stable-event-handler";
import { createSingletonHandler } from "../use-singleton-handler";
var useMutationSingleton = createSingletonHandler(function(handler) {
    var observer = new MutationObserver(function() {
        return handler();
    });
    observer.observe(document.body, {
        attributes: true,
        subtree: true
    });
    return function() {
        return observer.disconnect();
    };
});
/**
 * Fires onChange with the given target element as an argument every time any DOM node attribute changes.
 *
 * @deprecated The hook has performance implications. Consider alternatives.
 */ export function useMutationObserver(elementRef, onChange) {
    var handler = useStableEventHandler(function() {
        if (elementRef.current) {
            onChange(elementRef.current);
        }
    });
    useMutationSingleton(handler);
    useEffect(function() {
        handler();
    }, [
        handler
    ]);
} //# sourceMappingURL=index.js.map
